<!--    The Button that represents a Vehicle in the Device List 
        In The Case of CompoundMeters it only displays The Data of the main Watermeter in that configuration    -->
<!--Copy right - © 2024 tecera gmbh-->

<script>
    import { slide } from "svelte/transition";
    import {
        selected_device,
        modal_mode,
        is_modal_open,
    } from "../../stores.js";
    import DeviceButtonDataLine from "./buttons_parts/DeviceButtonDataLine.svelte";
    import { onMount } from "svelte";

    export let vehicle;

    let is_open = false;
    let buttonElement;
    let status, vehicle_config;

    onMount(() => {
        vehicle_config = vehicle.vehicle_config[0];
        status = vehicle_config.active == 1 ? "Aktiv" : "Inaktiv";
    });

    $: {
        if ($selected_device === vehicle) {
            is_open = true;
            if (buttonElement) {
                buttonElement.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                }); //TODO: disable on low width
            }
        } else {
            is_open = false;
        }
    }

</script>

{#if vehicle_config}
    <button
        on:click={() => {
            if ($selected_device === vehicle) {
                is_open = !is_open;
            } else {
                $selected_device = vehicle;
            }
        }}
        type="button"
        bind:this={buttonElement}
        class="btn btn-normal btn-transparent btn-block mt-0"
        ><div class="row bold">
            <div class="col-7 text-left">
                <p style="white-space: pre-line;" class="mb-0">
                    {vehicle_config.name
                        ? vehicle_config.name
                        : "unbennantes Fahrzeug"}
                </p>
            </div>
            <div class="col-3 text-left">{status}</div>
            <div class="col-2 text-right">
                <i class="arrow active {is_open ? 'up' : 'down'}"></i>
            </div>
        </div>
    </button>

    {#if is_open}
        <div transition:slide|local>
            <div class="gray">
                <DeviceButtonDataLine label="Status:" value={status} />
                <DeviceButtonDataLine
                    label="Tankfüllstand:"
                    value={vehicle?.last_data?.fuel_level ? vehicle?.last_data?.fuel_level + " l" : "--"}
                />
                                <DeviceButtonDataLine
                    label="Zündung:"
                    value={vehicle?.last_data?.ignition ? vehicle?.last_data?.ignition : "--"}
                />
                                <DeviceButtonDataLine
                    label="Geschwindigkeit:"
                    value={vehicle?.last_data?.speed ? vehicle?.last_data?.speed + " km/h" : "--"}
                />
                                <DeviceButtonDataLine
                    label="Kilometerstand:"
                    value={vehicle?.last_data?.total_kilometers ? vehicle?.last_data?.total_kilometers  +  " km" : "--"}
                />
                                <DeviceButtonDataLine
                    label="Batteriestand:"
                    value={vehicle?.last_data?.battery_voltage ? vehicle?.last_data?.battery_voltage  +  " V" : "--"}
                />
                
                                <DeviceButtonDataLine
                    label="Bemerkungen:"
                    value={vehicle_config.comment}
                />

                <div class="row">
                    <div class="col">
                        <button
                            class="btn btn-normal btn-transparent btn-underline gray bold"
                            on:click={() => {
                                $modal_mode = "edit";
                                $is_modal_open = true;
                            }}>Bearbeiten</button
                        >
                    </div>
                </div>
            </div>
        </div>
    {/if}
{/if}
